module.exports = __webpack_public_path__ + "0182c8ae4240eb5a14a004bdc879ff2f.pdf";